<div class="user-menu-dialog">
  <div class="user-header d-flex flex-col justify-center">
    <div class="user-profile d-flex flex-col justify-center align-center">
      <iw-avatar
        class="avatar"
        [avatar]="userProfile()?.avatar"
        [firstName]="userProfile()?.caption.at(0) ?? ''"
      />
      <div class="d-flex flex-col gap-1 justify-center">
        <div class="name">{{ userProfile()?.caption ?? "" }}</div>
        <div class="email">{{ userProfile()?.email ?? "" }}</div>
      </div>
    </div>
  </div>
  <div class="user-theme d-flex justify-center">
    <div class="theme-btn-wrapper">
      <iw-button uiType="custom" (click)="setTheme('light')">
        <div
          class="theme-button d-flex justify-center align-center light"
          [class.selected]="!themeService.isDarkTheme()"
        >
          <svg>
            <use
              [attr.xlink:href]="'assets/icons.svg#light-theme'"
              [attr.href]="'assets/icons.svg#light-theme'"
            ></use>
          </svg>
        </div>
      </iw-button>

      <span class="theme-text d-flex justify-center align-end">
        {{ "userCardSmall.btn.lightTheme" | translate }}</span
      >
    </div>

    <div class="theme-btn-wrapper">
      <iw-button uiType="custom" (click)="setTheme('dark')">
        <div
          class="theme-button d-flex justify-center align-center dark"
          [class.selected]="themeService.isDarkTheme()"
        >
          <svg>
            <use
              [attr.xlink:href]="'assets/icons.svg#dark-theme'"
              [attr.href]="'assets/icons.svg#dark-theme'"
            ></use>
          </svg>
        </div>
      </iw-button>

      <span class="theme-text d-flex justify-center align-end dark">
        {{ "userCardSmall.btn.darkTheme" | translate }}</span
      >
    </div>
  </div>
  <div class="user-actions d-flex flex-col align-start gap-2">
    <iw-button uiType="custom" [disabled]="true">
      <fu-icon iconName="language" size="16"></fu-icon>
      {{ "userCardSmall.btn.en" | translate }}
    </iw-button>
    <iw-button uiType="custom">
      <fu-icon iconName="message-square" size="16"></fu-icon>
      <a [href]="supportLink" target="_blank" rel="noopener noreferrer">
        {{ "userCardSmall.btn.chatSupport" | translate }}
      </a>
    </iw-button>
    <iw-button uiType="custom" (click)="openOrdersHistory()">
      <fu-icon iconName="receipt" size="16"></fu-icon>
      {{ "userCardSmall.btn.ordersHistory" | translate }}
    </iw-button>
    <iw-button uiType="custom" [disabled]="true">
      <fu-icon iconName="settings" size="16"></fu-icon>
      {{ "userCardSmall.btn.settings" | translate }}
    </iw-button>
  </div>
  <div class="logout">
    <iw-button uiType="primary" size="s" iconName="logout" (click)="logout()">
      {{ "user.logOut" | translate }}
    </iw-button>
  </div>
</div>
